export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 9a9 9 0 1118.001.001A9 9 0 010 9zm2 0c0 3.86 3.14 7 7 7s7-3.14 7-7-3.14-7-7-7-7 3.14-7 7zm7-1.41l2.29-2.3 1.42 1.42L10.41 9l2.3 2.29-1.42 1.42L9 10.42l-2.29 2.29-1.42-1.42L7.59 9l-2.3-2.29 1.42-1.42L9 7.59z\" fill=\"#ff00cb\" fill-opacity=\".9\"/>",
  "attrs": {
    "width": "18",
    "height": "18",
    "viewBox": "0 0 18 18",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};